import './style.css';
import './fonts.css';
import styled from 'styled-components';

const EmailLink = styled.a`
  color: #d8d8d8;
`;

// Component for TextCont
function TextCont() {
    return (
        <div id="textcont-background">
            <div id="textcont-container">
                <h1 id="textcont-title">Who am I ?</h1>
                    <div id="textcont-content">
                        <h2 id="textcont-sub-title">... Let's dig deeper</h2>
                        I am a DevOps Specialist with M.Sc degree in Health Technology (all the stuff related to data and AI!) and hands-on experience in developing CI/CD pipelines, Kubernetes orchestration and software testing practices, with a strong focus on the software development life cycle (SDLC). My academic and research background lies in Machine Learning and Natural Language Processing, where I specialize in predictive modeling and data-driven development. I am particularly interested in applying these technologies to solve real-life problems and to optimize organizational processes.
                        <h2 id="textcont-sub-title">Expertise</h2>
                        <ul>
                            <li>Machine Learning & Predictive Modeling</li>
                            <li>Natural Language Processing & Language Models</li>
                            <li>DevOps & CI/CD Pipelines</li>
                            <li>Kubernetes Orchestration</li>
                            <li>Agile & Scrum Workflows</li>
                            <li>Software Development Life Cycle (SDLC)</li>
                        </ul>
                    </div>
            </div>
        </div>
    );
}

export default TextCont;
